<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iv"><img alt='The Rose Bride: A Retelling of "The White Bride and the Black Bride", by Nancy Holder. Simon Pulse.' src="images/f0iii-01.jpg"/></a></h1><a id="page_iv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?68a1e460